export const autoevents = {
  "dashboardRefresh": 30000,
  "heartbeatInterval": 120000,
  "inactiveLimit": 1800,
};